const warning = {
  blue: {
    fontColor: "var(--app-text-17)",
    fillColor: "var(--app-text-17)",
  },
  yellow: {
    fontColor: "var(--app-text-18)",
    fillColor: "var(--app-text-19)",
  },
  orange: {
    fontColor: "var(--app-text-20)",
    fillColor: "var(--app-text-21)",
  },
  red: {
    fontColor: "var(--app-text-22)",
    fillColor: " var(--app-text-23)",
  },
};

export const appThemeStyle: any = {
  cloudy: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-01)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-26)",
      boxShadow: "var(--app-shadow-02)",
      backdropFilter: "blur(5px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-27)",
    },
    warning: warning,
  },
  thunder: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-03)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-08)",
      boxShadow: "var(--app-shadow-04)",
      backdropFilter: "blur(5px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-28)",
    },
    warning: warning,
  },
  rain: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-03)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-29)",
      boxShadow: "var(--app-shadow-05)",
      backdropFilter: "blur(3px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-30)",
    },
    warning: warning,
  },
  sunshine: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-01)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-31)",
      boxShadow: "var(--app-shadow-02)",
      backdropFilter: "blur(2px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-32)",
    },
    warning: warning,
  },
  snow: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-01)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-33)",
      boxShadow: "var(--app-shadow-02)",
      backdropFilter: "blur(5px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-34)",
    },
    warning: warning,
  },
  rain_snow: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-06)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-35)",
      boxShadow: "var(--app-shadow-07)",
      backdropFilter: "blur(2px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-36)",
    },
    warning: warning,
  },
  night: {
    headerStyle: {
      backgroundColor: "var(--app-bg-25)",
      boxShadow: "var(--app-shadow-08)",
      backdropFilter: "blur(28px)",
    },
    mainItemStyle: {
      backgroundColor: "var(--app-bg-37)",
      boxShadow: "var(--app-shadow-08)",
      backdropFilter: "blur(2px)",
    },
    tipsStyle: {
      backgroundColor: "var(--app-bg-38)",
    },
    warning: warning,
  },
};
